"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnleashThePowerOfProGroupsHeavyMachinery() {
  const {
    ref: cardRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const [scrollY, setScrollY] = useState(0);
  const [cursorPosition, setCursorPosition] = useState({
    x: 0,
    y: 0
  });
  const [isHovering, setIsHovering] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    const handleMouseMove = (e: MouseEvent) => {
      setCursorPosition({
        x: e.clientX,
        y: e.clientY
      });
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);
  useEffect(() => {
    if (!buttonRef.current || !isHovering) return;
    const button = buttonRef.current;
    const rect = button.getBoundingClientRect();
    const buttonCenterX = rect.left + rect.width / 2;
    const buttonCenterY = rect.top + rect.height / 2;
    const deltaX = cursorPosition.x - buttonCenterX;
    const deltaY = cursorPosition.y - buttonCenterY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const maxDistance = 120;
    const pullStrength = Math.max(0, 1 - distance / maxDistance);
    const translateX = deltaX * pullStrength * 0.15;
    const translateY = deltaY * pullStrength * 0.15;
    button.style.transform = `translate(${translateX}px, ${translateY}px)`;
  }, [cursorPosition, isHovering]);
  const parallaxOffset = scrollY * 0.5;
  return <section className="relative h-screen w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-fast)] ease-linear" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/massive_excavator_digging_construction_site.png)",
      transform: `translateY(${parallaxOffset}px)`
    }}>
        {}
        <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='2.5' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        backgroundRepeat: "repeat"
      }} />
      </div>

      {}
      <div className="absolute inset-x-0 bottom-0 flex items-end justify-center px-6 pb-16 md:pb-24">
        <Card ref={cardRef} className={`glass-effect w-full max-w-3xl shadow-strong transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <CardContent className="flex flex-col items-center gap-8 px-8 py-10 text-center md:px-12 md:py-14">
            <h1 className="font-display text-4xl font-bold leading-tight tracking-tight text-foreground md:text-5xl lg:text-6xl">
              Libere el poder de la maquinaria pesada de ProMáquinas
            </h1>

            <p className="max-w-2xl text-lg text-foreground/80 md:text-xl">
             Potencie sus proyectos con una completa gama de retroexcavadoras, excavadoras, motoniveladoras, cargadores frontales, rodillos compactadores, bulldozers y equipos industriales, diseñados para entregar máximo rendimiento, confiabilidad y eficiencia en las industrias más exigentes de Chile.
            </p>

            <div ref={buttonRef} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => {
            setIsHovering(false);
            if (buttonRef.current) {
              buttonRef.current.style.transform = "translate(0, 0)";
            }
          }} className="transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              <Link to="/HeavyMachineryPage">
                <Button size="lg" className="btn-primary text-base font-semibold shadow-medium md:text-lg">
                  Explorar máquinas
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}